import styled from 'styled-components';

export default styled.div`
  display: block;
  position: relative;
  width: 100vw;
  height: 100vh;
  text-align: left;
  
  .mapboxgl-map {
    text-align: left;
  }
`;
